import type {
  AlloyLegacyThemeDesignTokens,
  HighlightTextDesignTokens,
} from '../types';
import type { Weave3InputInput } from '../types/weave3Types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getHighlightTextTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): HighlightTextDesignTokens => ({
  'background-color': theme.tokens.colors.background.highlight.value,
});

export const getHighlightTextTokensWeave = (
  tokens: WeaveTokens,
): HighlightTextDesignTokens => ({
  'background-color': tokens?.component?.input?.['background-color']?.selected,
});

/** No Weave highlight component exists; both borrow the input selection swatch. */
export const getHighlightTextTokensWeave3 = (
  input?: Weave3InputInput,
): HighlightTextDesignTokens => ({
  'background-color': input?.['background-color']?.selected,
});
